import {combineReducers} from 'redux'

import storage from 'redux-persist/lib/storage'

import {evaluation, currentEvaluation, answer} from './evaluation';

const appReducer = combineReducers({
    evaluation,
    currentEvaluation,
    answer,
});
const rootReducer = (state, action) => {
    if (action.type === 'RESET') {
        Object.keys(state).forEach(key => {
            storage.removeItem(`persist:${key}`);
        });
        state = {lang: state.lang}
    }
    return appReducer(state, action)
};

export default rootReducer